import { render, staticRenderFns } from "./SaveDashboardAsModal.vue?vue&type=template&id=a751aeae&"
import script from "./SaveDashboardAsModal.vue?vue&type=script&lang=js&"
export * from "./SaveDashboardAsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports